/**
 * 阅读器构造器按类型懒加载解析器
 */

function normalizeReaderType(fileType) {
  if (fileType === 'azw3') return 'mobi';
  return fileType;
}

export function createReaderConstructorResolver(importWithChunkRecovery) {
  const readerCtorCache = {
    pdf: null,
    epub: null,
    mobi: null
  };

  const readerCtorLoadingPromises = {
    pdf: null,
    epub: null,
    mobi: null
  };

  return async function getReaderConstructor(fileType) {
    const type = normalizeReaderType(fileType);
    if (!readerCtorCache[type]) {
      if (!readerCtorLoadingPromises[type]) {
        readerCtorLoadingPromises[type] = (async () => {
          if (type === 'pdf') {
            const mod = await importWithChunkRecovery(() => import('../readers/pdfReader.js'));
            readerCtorCache.pdf = mod?.PDFReader || null;
          } else if (type === 'epub') {
            const mod = await importWithChunkRecovery(() => import('../readers/epubReader.js'));
            readerCtorCache.epub = mod?.EPUBReader || null;
          } else if (type === 'mobi') {
            const mod = await importWithChunkRecovery(() => import('../readers/mobiReader.js'));
            readerCtorCache.mobi = mod?.MOBIReader || null;
          } else {
            throw new Error(`Unsupported reader type: ${fileType}`);
          }
          return readerCtorCache[type];
        })().finally(() => {
          readerCtorLoadingPromises[type] = null;
        });
      }
      await readerCtorLoadingPromises[type];
    }

    const ctor = readerCtorCache[type];
    if (!ctor) {
      throw new Error(`Reader constructor missing for type: ${fileType}`);
    }
    return ctor;
  };
}
